import { useMediaQuery } from '@mantine/hooks';

export const useResponsiveOrder = (mobile, tablet, desktop) => {
  const isMobile = useMediaQuery('(max-width: 48em)');
  const isTablet = useMediaQuery('(min-width: 48em) and (max-width: 64em)');

  if (isMobile) return mobile;
  if (isTablet) return tablet;
  return desktop;
}; 